import React from 'react';
import ReactDOM from 'react-dom/client';
import FerretiCVChat from './FerretiCVChat';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FerretiCVChat />
  </React.StrictMode>
);
